import CustomCard from "components/Atoms/CustomCard"
import TablePagination from "components/Molecules/TablePagination"
import ModuleHeader from "components/Templates/ModuleHeader"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React from "react"
import UploaderDialog from "./UploaderDialog"
import UploaderFilter from "./UploaderFilter"

const UploaderHeader = ({ children, refetch }) => {
  const [{ search, page }, setFilter] = useSearchFilter()

  return (
    <div className="p-3">
      <CustomCard className="p-0">
        <ModuleHeader
          filter={<UploaderFilter />}
          borderBottom="none"
          query={search ?? ""}
          onQueryChange={search => {
            setFilter(prev => ({
              ...prev,
              search,
              page: 0,
            }))
          }}
          white
          className="p-3"
          placeholder="Search by Batch name"
        >
          <TablePagination
            className="mr-3"
            page={page}
            onPageChange={pg => {
              setFilter(prev => ({
                ...prev,
                page: pg,
              }))
            }}
          />
          <UploaderDialog refetch={refetch} />
        </ModuleHeader>
        {children}
      </CustomCard>
    </div>
  )
}

export default UploaderHeader
